import React from "react";
import { Row, Col, Card } from "antd";
import { IoIosAddCircleOutline } from "react-icons/io";
import "./index.css";

export default function AddPlantCard({
  cardText,
  cardIcon,
  cardStyle,
  onChangePlantModal,
  ...props
}) {
  return (
    <Row justify="center">
      <Col
        xs={24}
        sm={24}
        md={24}
        lg={24}
        xl={24}
        className="payment-card pointer-cursor"
        onClick={onChangePlantModal}
      >
        <Card className="ant-card-body" style={cardStyle}>
          <Row justify="center" align="middle">
            <Col className="addNew-Plant" style={{ marginTop: "-1.8rem" }}>
              {cardIcon}
              <p>{cardText}</p>
            </Col>
          </Row>
        </Card>
      </Col>
    </Row>
  );
}
